import React, { useEffect, useState } from 'react';
import '../Companies.css';
import { Outlet, useNavigate } from 'react-router-dom';
import {Form, Row, Col, Table, Card} from 'react-bootstrap';
import { AiFillEdit } from 'react-icons/ai';
import { MdAddCircle } from 'react-icons/md';
import FilterAPIs from '../../../../MasonyFixingsAPIs/FilterAPIs/FilterAPIs';
import { FaArrowAltCircleRight } from 'react-icons/fa';


export default function CompaniesHome(){

    const ColumnHeaders = [
        {name: ''},
        // {name: 'Delete'},
        {name: ''},
    ]
    const [addNew, setAddNew] = useState(false);
    const navigate = useNavigate();
       
    const [searchString, setSearchString] = useState('');
    const [CompaniesData, setCompaniesData] =  useState([]);
    const [selectedCompany, setSelectedCompany] =  useState();
    const [showCompany, setShowCompany] =  useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    const getAllCompanies = (string) => {

        const postJSON = {
            name: string
        }
        FilterAPIs.PostCompanyFilter(postJSON)
        .then((response) => {
            setCompaniesData(response.data);
        }) 
        .catch((err) => {
            console.log(err)
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }

    const handleAddNew = () => {
        
        setAddNew(false);        
        setSearchString('');
        getAllCompanies('');
    }

    const handleCancel = () => {
        setAddNew(false);
    }

    const handleSelect = (id) => {
        setSelectedCompany(id);
        setShowCompany(true);
    }

    const handleClose = () => {
        setShowCompany(false);
        setSelectedCompany();
    }

    useEffect(() => {
        getAllCompanies(searchString);
    }, [searchString])


    const ThData = () => {
        return ColumnHeaders.map((header, index) => {
            return(
                <th key={index}>{header.name}</th>
            )
        })
    }

    const tdData = () => {
        return CompaniesData.map((company) => {
            return(
                <tr key={company.id}>
                    <td>{company.name}</td>
                    <td className='project-header-actions'><button className='edit-btn' onClick={() => navigate('/companies/' + company.id)}><FaArrowAltCircleRight/></button></td>
                </tr>
            )
        })
    }

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    
    return(

        <div className='company-display'>

            <div>
                
                    
                    <div>
                        <Card className={`projects-search-card floating-search ${isScrolled ? 'shrink' : ''}`}>
                <Card.Body>
                    <Row className="mb-2">
                        <Col sm={8}>
                            <div className="projects-search-container">
                                <Form.Label>({CompaniesData.length}) Search Company:</Form.Label>
                                <Form.Control
                                    value={searchString}
                                    onChange={(e) => setSearchString(e.target.value)}
                                    placeholder="Enter a company name..."
                                />
                            </div>
                        </Col>
                        <Col className="projects-add-col">
                            <button 
                                className="projects-add-btn"
                                onClick={() => navigate('create')}
                            >
                                <MdAddCircle />
                                <span>Add Company</span>
                            </button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
                    <div className="projects-table-card">
                        <Card className="projects-table-card">
                                    <Card.Body>
                        
                        <Table size='sm' striped hover responsive>
                            <thead>
                                <tr>
                                    {ThData()}
                                </tr>
                            </thead>
                            <tbody>
                                {tdData()}
                            </tbody>
                        </Table>
                        </Card.Body>
                        </Card>
                    </div>
                    </div>
                    
                
            </div>
            
        </div>
    )
}
